import { ChevronRightIcon } from '@c/icons';
import Link from 'next/link';
import React from 'react';

const NavMenuSection = ({
  label,
  href,
  children,
  onClick,
}: {
  label: string;
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <div className="flex w-[35rem] flex-col px-4">
      <Link
        href={href}
        onClick={onClick}
        className="group flex w-full items-center gap-x-4 border-b border-zinc-400 pb-2 text-[1.6rem] font-bold capitalize hover:text-brand-secondary"
      >
        {label}

        <ChevronRightIcon />
      </Link>

      {children}
    </div>
  );
};

export default NavMenuSection;
